import { Download } from "lucide-react";
import { GRAPHIC_FILES, TIP_UI } from "@/lib/sealingTips";

export const GraphicDownloads = ({ compact = false, lang = "en" }) => (
  <div className={compact ? "" : "card-flat"} data-testid="graphic-downloads">
    {!compact && (
      <>
        <p className="eyebrow">Graphics for partners</p>
        <h3 className="font-serif text-xl mt-1 text-[#1C201F]">Radon entry-points graphic</h3>
        <p className="text-sm text-[#5C6661] mt-1">
          Free to share in newsletters, on social media and in printed materials.
        </p>
      </>
    )}
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 ${compact ? "" : "mt-4"}`}>
      {GRAPHIC_FILES.map((g) => (
        <div key={g.id} className="flex items-center gap-3 rounded-xl border border-[#E8ECEA] p-3">
          {!compact && <img src={g.square} alt="" className="w-14 h-14 rounded-lg object-cover shrink-0" loading="lazy" />}
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#1C201F]">{g.label}</p>
            <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1">
              {["full", "square"].map((k) => (
                <a key={k} href={g[k]} download={g[k].split("/").pop()}
                  className="text-xs font-semibold text-[#2F524A] hover:underline inline-flex items-center gap-1"
                  data-testid={`graphic-download-${g.id}-${k}${compact ? "" : "-admin"}`}>
                  <Download size={12} /> {TIP_UI[lang][k]}
                </a>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
